import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import Navbar from './header/Navbar';
import Snackbar, { openSnackbar } from './utils/Snackbar';
import axios from '../axios/axios';
import CircularProgress from '@material-ui/core/CircularProgress';
import qs from 'query-string';
import { Helmet } from "react-helmet";
// import Button from '@material-ui/core/Button';

const style = theme => ({
    container: {
        maxWidth: "965px",
        margin: '0 auto',
        padding: '20px 0',
        // textAlign: 'center',
        [theme.breakpoints.down('sm')]: {
            width: '90%',
        },
    },
    blogImage: {
        width: '100%',
        height: 'auto',
        margin: '0 auto',
        [theme.breakpoints.down('sm')]: {
            width: '100%',
        },
    },
    blogDate: {
        margin: '5px 0 20px 0',
        fontSize: '15px',
        color: '#708090',
        fontStyle: "italic",
        [theme.breakpoints.down('sm')]: {
            fontSize: '12px'
        }
    },
    blogTitle: {
        margin: '10px 0 5px 0',
        fontSize: '30px',
        fontWeight: "700",
        lineHeight: "1.8",
        letterSpacing: '.5px',
        fontFamily: "Playfair Display,serif",
        [theme.breakpoints.down('sm')]: {
            fontSize: '22px',
        },
    },
    blogContent: {
        maxWidth: "965px",
        margin: "10px auto",
        fontFamily: 'Merriweather, serif',
        fontWeight: 300,
        lineHeight: 1.8,
        letterSpacing: '.5px',
        '& p': {
            margin: '10px 0',
            '& img': {
                display: 'block',
                width: '70%',
                margin: '0 auto'
            },

        },
        '& blockquote': {
            padding: '10px 5px',
            background: '#34495E',
            color: '#fff',
            borderRadius: '5px',
            fontStyle: "italic",
            margin: '2px 0',
        },
        '& code': {
            background: 'rgb(242, 242, 242)',
            borderRadius: '10px',
            padding: "5px",
            margin: '0 auto',
            fontSize: "12px"
        },
        '& img': {
            width: '100%'
        },
        [theme.breakpoints.down('sm')]: {
            paddingRight: '10px',
        }
    },
    progress: {
        margin: theme.spacing.unit * 2,
    },
    button: {
        margin: "10px auto"
    }
});

class BlogPage extends Component {
    constructor(props) {
        super(props);

        this.state = {
            blog: {
                title: "Asyncentric Technologies | Software & Web Development Company"
            },
            loading: true
        }
    }

    componentDidMount() {
        this.fetchBlog();
    }

    fetchBlog = () => {
        let id = qs.parse(this.props.location.search, { ignoreQueryPrefix: true }).id;
        axios.get('blog/getBlog/' + id).then(result => {
            if (result.status === 200) {
                if (result.data.success) {
                    this.setState({
                        blog: result.data.blog,
                        loading: false
                    });
                } else {
                    this.setState({
                        loading: false
                    });
                    openSnackbar({ message: result.data.msg, variant: "error" });
                }
            } else {
                openSnackbar({ message: "Something went wrong", variant: "error" });
            }
        }).catch(error => {
            openSnackbar({ message: "Something went wrong", variant: "error" });
        });
    }

    render() {
        const { classes } = this.props;
        return (
            <Fragment>
                <Helmet>
                    <meta charSet="utf-8" />
                    <title>{`${this.state.blog.title} - Asyncentric Technologies`}</title>
                </Helmet>
                <Navbar />
                <Snackbar />
                <section className={classes.container}>
                    <Typography variant="h3" className={classes.blogTitle}>{this.state.blog.title}</Typography>
                    <Typography variant="h4" className={classes.blogDate}>{this.state.blog.createdAt}</Typography>
                    <img src={this.state.blog ? this.state.blog.imageUrl : "https://firebasestorage.googleapis.com/v0/b/asyncentric-tech.appspot.com/o/default.jpg?alt=media&token=2913d7c6-b68d-453c-b5cf-3902746df4f2"} alt={this.state.blog ? this.state.blog.title : null} className={classes.blogImage} />

                    <br />
                    {/* <Button variant="outlined" color="secondary" onClick={() => {
                        openSnackbar({ message: "Copy above URL to share", variant: 'info' });
                    }} className={classes.button}>Share</Button> */}
                    <br />
                    <div className={classes.blogContent}
                        dangerouslySetInnerHTML={{ __html: this.state.blog.content }}
                    />
                    {this.state.loading ? (<CircularProgress className={classes.progress} color="secondary" />) : null}
                    <br />
                </section>
            </Fragment >
        );
    }
}

BlogPage.propTypes = {
    classes: PropTypes.object.isRequired,
}

export default withStyles(style)(BlogPage);